import { render, staticRenderFns } from "./control.vue?vue&type=template&id=725842fa&scoped=true&"
import script from "./control.vue?vue&type=script&lang=js&"
export * from "./control.vue?vue&type=script&lang=js&"
import style0 from "./control.vue?vue&type=style&index=0&id=725842fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725842fa",
  null
  
)

export default component.exports